export const ChatTopEnum = {
  TOP: 1, // 置頂
  NOT_TOP: 0, // 不是置頂
};

export const ChatType = {
  ALL: 1, //全部
  NEW: 2, //新消息
  UNANSWERED: 3, //未回覆
  KEY_CUSTOMERS: 4, // 重要老客
  PAID_CHATROOM: 5, //付費諮詢室
  CARD_CLIENT: 6, //牌陣客户
  HISTORY_CHATROOM: 8, //歷史諮詢室
  COFFEE: 9, //咖啡廳客户
  TAROT_ONLINE_UNREAD: 10, //塔羅和在線未讀報告
};

export const loadChatType = {
  ALL: 1, //全部
  NEW: 2, //新消息
  UNANSWERED: 3, //未回覆
};

export const RETURN_VISIT = 999; // 每日回訪
